import { Locales } from "@simplyk/common";

import { LiveFormRemindersOutput } from "@/common/types/trpc";

export type ReminderTranslationKey = "reminder1" | "reminder2";

export type ReminderTranslationDefaults = {
  key: ReminderTranslationKey;
  fields: { subject: string; body: string };
  translations: { subject: string; body: string };
};

export const getEnabledReminderTranslations = (
  remindersData: LiveFormRemindersOutput | undefined,
  translationLocale: Locales
): ReminderTranslationDefaults[] => {
  if (!remindersData?.usesV2Reminders) {
    return [];
  }

  const keys: ReminderTranslationKey[] = ["reminder1", "reminder2"];

  return keys.flatMap((key) => {
    const reminder = remindersData[key];
    if (!reminder || reminder.scheduleOffset === null) {
      return [];
    }

    const translation = reminder.translations.find((row) => row.locale === translationLocale);

    return [
      {
        key,
        fields: { subject: reminder.subject, body: reminder.body },
        translations: { subject: translation?.subject ?? "", body: translation?.body ?? "" },
      },
    ];
  });
};
